export const SET_PRICE_SUBSCRIBER = "SET_PRICE_SUBSCRIBER"
export const SET_PRICE_TYPE = "SET_PRICE_TYPE"
export const UPDATE_PRICE_SUBSCRIBER = "UPDATE_PRICE_SUBSCRIBER"
export const SET_BOTH_CALENDAR = "SET_BOTH_CALENDAR"